import { theme } from '../../styles';
import { Swapper } from '../../components';
import { NavWrapper, NavLinkWrapper, ImageOverlay, NavImage } from './style';
import { ContractIcon, GalleryIcon, ContactsIcon } from '../../assets/svg';
import termsImg from '../../assets/home/terms.png';
import pricesImg from '../../assets/home/prices.png';
import contactImg from '../../assets/home/contact.png';

const NavLink = ({ to, state, image, children, icon, animateDelay = theme.delayMd }) => (
  <NavLinkWrapper
    to={to}
    state={state}
    initial={theme.fadeIn.initial}
    animate={theme.fadeIn.animate}
    transition={theme.fadeIn.transition(animateDelay)}
    style={{ whiteSpace: 'pre-line' }}
  >
    <Swapper
      height='4em'
      swapChildren={icon}
    >
      {children}
    </Swapper>
    <ImageOverlay />
    <NavImage image={image} />
  </NavLinkWrapper>
);

const HomeNav = () => {
  return (
    <NavWrapper>
      <NavLink
        to='/terms'
        icon={<ContractIcon />}
        image={termsImg}
        animateDelay={theme.delayLg}
      >
        Terms
      </NavLink>
      <NavLink
        to='/prices'
        icon={<GalleryIcon />}
        image={pricesImg}
      >
        Prices
      </NavLink>
      <NavLink
        to='/contact'
        icon={<ContactsIcon />}
        image={contactImg}
        animateDelay={theme.delayLg}
      >
        Contact
      </NavLink>
    </NavWrapper>
  );
};

export default HomeNav;
